import { render } from "./DynamicPageList.vue?vue&type=template&id=d641bd3c&scoped=true"
import script from "./DynamicPageList.vue?vue&type=script&lang=js"
export * from "./DynamicPageList.vue?vue&type=script&lang=js"

import "./DynamicPageList.vue?vue&type=style&index=0&id=d641bd3c&scoped=true&lang=css"

import exportComponent from "/builds/weborigo-projects/vivien-vance/webshop/core-editor/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d641bd3c"]])

export default __exports__